"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormUpload = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var react_dropzone_1 = require("react-dropzone");
var ra_fetch_1 = require("ra-fetch");
function progress(loaded, total) {
    var progress = 0;
    if (total > 0) {
        progress = Math.round(loaded / total * 100);
    }
    return progress;
}
function upload(file, options, setUpload, setProgress) {
    var aws = options.aws;
    var req = new XMLHttpRequest();
    req.open('put', aws.endpoint, true);
    req.onload = function () {
        var params = {
            type: options.type || 'vod',
            channel_id: options.channel_id,
            user_id: options.user_id,
            external_id: options.external.id,
            resource: 'VideoFull',
            title: file.name,
        };
        if (options.category_id) {
            params.category_id = options.category_id;
        }
        ra_fetch_1.Fetcher.api('backend').store('videos', params).then(function (response) { return setUpload(response.data); });
    };
    req.upload.onprogress = function (event) { return setProgress(progress(event.loaded, event.total)); };
    req.send(file);
}
function Dropzone(_a) {
    var children = _a.children, setProgress = _a.setProgress, video = _a.video, setUpload = _a.setUpload;
    var onDrop = react_1.useCallback(function (files) {
        // if (rejected.length) {
        //     return setMessage('Kies een video bestand!')
        // }
        //
        // if (!files.length) {
        //     return setMessage('Geen video gevonden!')
        // }
        var name = Date.now() + '-' + files[0].name;
        ra_fetch_1.Fetcher.api('backend').store('videos.external', {
            channel_id: video.channel_id,
            name: name,
            status: 'unpublished',
            user_id: video.user_id,
            type: files[0].type,
        }).then(function (response) {
            return upload(files[0], {
                type: video.type,
                category_id: video.category_id,
                user_id: video.user_id,
                channel_id: video.channel_id,
                external: response.data,
                aws: response.aws,
            }, setUpload, setProgress);
        });
    }, []);
    var _b = react_dropzone_1.useDropzone({ onDrop: onDrop }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps;
    return react_1.default.createElement("div", __assign({}, getRootProps()),
        react_1.default.createElement("input", __assign({}, getInputProps())),
        children);
}
function Preview(_a) {
    var children = _a.children;
    return react_1.default.createElement("div", null, children);
}
var messages = {
    ads: 'De video wordt verwerkt en is binnen enkele minuten beschikbaar',
    vod: 'De video wordt verwerkt en is binnen enkele minuten beschikbaar',
};
function FormUpload(_a) {
    var video = _a.video, setUpload = _a.setUpload;
    var _b = react_1.useState(0), progress = _b[0], setProgress = _b[1];
    var Container = progress === 100 ? Preview : Dropzone;
    return react_1.default.createElement("div", { className: 'storybook-videos-form-upload' },
        react_1.default.createElement("div", null,
            react_1.default.createElement(Container, { video: video, setUpload: setUpload, setProgress: setProgress },
                progress < 1 && react_1.default.createElement(storybook_1.Buttons.Button, null,
                    react_1.default.createElement("span", { className: storybook_1.Helpers.classNames('storybook-videos-form-upload-dropbox', progress === 100 ? 'bg-secondary' : 'bg-white') },
                        react_1.default.createElement(storybook_1.Icons.Icon, { name: 'cloud-upload', className: 'w-10 -mb-1' })),
                    react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: 'text-white' }, "Video selecteren"),
                    react_1.default.createElement(storybook_1.Texts.Primary, { className: 'text-white font-thin' }, "of sleep een video naar dit vlak"),
                    react_1.default.createElement(storybook_1.Texts.Small, { className: 'text-white font-thin p-3' }, "(maximale bestandsgrootte 4.9GB)")),
                progress > 0 && react_1.default.createElement("div", null,
                    react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: 'text-white mb-4' }, progress < 100 ? 'Video uploaden...' : messages[video.type]),
                    react_1.default.createElement("div", { className: 'storybook-videos-form-upload-uploader' },
                        react_1.default.createElement("div", { className: 'storybook-videos-form-upload-loadbar' },
                            react_1.default.createElement("div", { style: { width: progress + "%" } })))))));
}
exports.FormUpload = FormUpload;
FormUpload.propTypes = {
    /**
     * Video
     */
    video: prop_types_1.default.shape({
        user_id: prop_types_1.default.number.isRequired,
        channel_id: prop_types_1.default.number.isRequired,
    }).isRequired,
};
